import { useOktaAuth } from '@okta/okta-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectFeatureFlag } from '@store/reducers/config.reducer';
import jwtDecode from 'jwt-decode';
declare global {
    interface Window {
        VWO: any;
        isVWOReady: boolean;
    }
}
export const useVWO = () => {
    const { authState } = useOktaAuth();
    const {
        isAuthenticated,
        accessToken: { accessToken }
    } = authState;
    const isVWOEnabled = useSelector(state => selectFeatureFlag(state, 'vwoIntegration'));
    const isMounted = useRef<boolean>(false);
    console.log('Before vwo initialised');
    useEffect(() => {
        if (typeof window.isVWOReady === 'undefined') {
            window.isVWOReady = false;
        }
    }, []);
    const RecordVWOAttributes = useCallback(
        (attributesAndValues: Record<string, any>) => {
            if (isVWOEnabled && window.isVWOReady) {
                window.VWO = window.VWO || [];
                window.VWO.visitor =
                    window.VWO.visitor ||
                    function () {
                        // eslint-disable-next-line
                    window.VWO.push(['visitor'].concat([].slice.call(arguments)));
                    };
                Object.entries(attributesAndValues).forEach(([key, value]) => {
                    window.VWO.visitor({ [key]: value });
                });

                console.log('Recorded VWO Attributes ', attributesAndValues);
            }
        },
        [isVWOEnabled]
    );

    const initializeVWO = useCallback(
        (accessToken: string) => {
            try {
                const { uuid: OKTA_UUID } = jwtDecode<{ uuid: string }>(accessToken);
                console.log('vwo enabled', window.VWO, isVWOEnabled, OKTA_UUID);
                if (isVWOEnabled && window.VWO && OKTA_UUID) {
                    window.isVWOReady = true;
                    RecordVWOAttributes({ oktauuid: OKTA_UUID });
                    console.log('vwo initialised');
                }
            } catch (e) {
                console.log(e);
                throw new Error('Error initializing VWO');
            }
        },
        [isVWOEnabled]
    );

    useEffect(() => {
        if (isAuthenticated && isVWOEnabled && !isMounted.current) {
            initializeVWO(accessToken);
            isMounted.current = true;
        }
    }, [isAuthenticated, isVWOEnabled, initializeVWO, accessToken]);

    function RecordVWOEvent(eventname: any, attributes: any) {
        if (isVWOEnabled && window.isVWOReady) {
            window.VWO = window.VWO || [];
            window.VWO.event =
                window.VWO.event ||
                function () {
                    // eslint-disable-next-line
                    window.VWO.push(['event'].concat([].slice.call(arguments)));
                };
            window.VWO.event(eventname, attributes);
            console.log('Recorded VWO Event ', eventname, attributes);
        }
    }

    return { RecordVWOAttributes, RecordVWOEvent };
};
